export function formatCurrency(
  value?: number | string | null,
  fallback = 'N/A'
): string {
  const numericValue =
    typeof value === 'string' ? parseFloat(value) : value

  if (numericValue === null || numericValue === undefined || isNaN(numericValue)) {
    return fallback
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  })

  return formatter.format(numericValue)
}